import dayjs from 'dayjs';
/**
 * The appointments of a booking in the order of their date and time. A booking keeps them in the order they
 * were added, so anything that lists them - the overview, the summary, the order lines - sorts them first,
 * or an appointment added later shows up before an earlier one.
 */
export const appointmentsInOrder = (appointments) => [...(appointments !== null && appointments !== void 0 ? appointments : [])].sort((a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf());
export const apptypeNamesFor = (appointment, apptypes) => {
    var _a;
    const component = appointment.components[0];
    const names = [];
    (_a = component === null || component === void 0 ? void 0 : component.appointmentTypes) === null || _a === void 0 ? void 0 : _a.forEach((id) => {
        const apptype = apptypes.find((apptype) => apptype.id === id);
        if (apptype)
            names.push(apptype.name);
    });
    return names;
};
export const resourceNamesFor = (appointment, resources) => {
    var _a;
    const component = appointment.components[0];
    const names = [];
    (_a = component === null || component === void 0 ? void 0 : component.resources) === null || _a === void 0 ? void 0 : _a.forEach((id) => {
        const resource = resources.find((resource) => resource.id === id);
        if (resource)
            names.push(resource.name);
    });
    return names;
};
/** Which capacity-group names the current flow's capacity picker defines, if any - static per
 *  flow, so a caller should find this once (e.g. in a `useMemo`) rather than per appointment. */
export const capacityGroupNamesFrom = (views) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = views.find((view) => {
        var _a;
        const capacityComponent = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => component.picker === 'capacity');
        return capacityComponent === null || capacityComponent === void 0 ? void 0 : capacityComponent.config.groups;
    })) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b.find((component) => component.picker === 'capacity')) === null || _c === void 0 ? void 0 : _c.config.groups;
};
/** A label for what a SPECIFIC appointment was booked for - "1 Kinderen, 2 Volwassenen" - or ''
 *  when it carries no capacity data at all (no capacity picker on that apptype). Shown whenever
 *  there was a real answer to show, even a single "1 Kinderen": it was still an explicit choice,
 *  not a default worth hiding. */
export const capacityLabelFor = (appointment, groupNames, translate, i18nGroup) => {
    var _a, _b, _c;
    const capacity = (_a = appointment.capacity) !== null && _a !== void 0 ? _a : 0;
    const groups = (_b = appointment.capacityGroups) !== null && _b !== void 0 ? _b : {};
    if (groups[0]) {
        return translate.ts('%capacity% personen', { capacity: capacity.toString() }, i18nGroup);
    }
    const parts = [];
    for (const [key, value] of Object.entries(groups)) {
        if (key !== '0' && value > 0) {
            const groupName = (_c = groupNames === null || groupNames === void 0 ? void 0 : groupNames.find((group) => group.id === parseInt(key))) === null || _c === void 0 ? void 0 : _c.name;
            if (groupName) {
                parts.push(translate.ts('%capacity% %groupName%', { capacity: value, groupName: translate.t(groupName, 'select') }, i18nGroup));
            }
        }
    }
    return parts.join(', ');
};
